export default {

  Auth: {

    Cognito: {

        // REQUIRED - Amazon Cognito Region
        region: 'us-east-2',

        //PROD
        userPoolId: 'us-east-2_QZEsuVJkz',

        //PROD
        userPoolClientId: '64prle8qleuppo8730v44r16bn',

    }
  }
}